var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"sm8":"","offset-sm2":"","id":"loginRedirect"}},[_c('i',[_vm._v("We will log you in ... please wait.")])])}
var staticRenderFns = []

export { render, staticRenderFns }